/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.page-teams[_ngcontent-%COMP%]{padding:7px 0 30px}.page-teams[_ngcontent-%COMP%]   .page-breadcrumb[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:10px}.page-teams[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#3d516f}.page-teams[_ngcontent-%COMP%]   .team-nav[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:10px 0 25px}.page-teams[_ngcontent-%COMP%]   .team-nav[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{font-size:.75rem;min-width:145px}"];
export { styles as styles };
